(function () {
  'use strict';

  function initFooter(root) {
    if (!root || root.__nuceryFooterBound) return;
    root.__nuceryFooterBound = true;

    root.querySelectorAll('[data-nucery-footer-trigger]').forEach(function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) {
          panel.setAttribute('hidden', '');
        } else {
          panel.removeAttribute('hidden');
        }
      });
    });

    var locForm = root.querySelector('.nucery-footer__localization-form');
    if (locForm) {
      locForm.querySelectorAll('select').forEach(function (select) {
        select.addEventListener('change', function () {
          locForm.submit();
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.nucery-footer').forEach(initFooter);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (el && el.querySelector) {
      var footer = el.querySelector('.nucery-footer') || (el.classList && el.classList.contains('nucery-footer') ? el : null);
      if (footer) initFooter(footer);
    }
  });
})();
